import styled from "@emotion/styled";
import Footer from "./shared/Footer";
import Navbar from "./shared/Navbar";

export default function CookiePolicy() {
  return (
    <RootWrapperContactus>
    
      <Section>
        <Wrapper>
          <ReferAFriend>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
             Cookie Policy
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  A legal disclaimer
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
          </ReferAFriend>
        </Wrapper>
      </Section>
      
    </RootWrapperContactus>
  );
}

const RootWrapperContactus = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  /* min-height: 100vh; */
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  /* padding-top: 98px;
    @media (max-width: 1024px) and (min-width: 768px) {
    padding-top: 73px;
  }

  @media (max-width: 767px) {
    padding-top: 73px;
  }
  padding-top: 98px;
    @media (max-width: 1024px) and (min-width: 768px) {
    padding-top: 73px;
  }

  @media (max-width: 767px) {
    padding-top: 73px;
  } */
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
  min-height: 666px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
      @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ReferAFriend = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 1200px;
  box-sizing: border-box;
      @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
    @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 24px;
    letter-spacing: -0.48px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
    letter-spacing: -0.48px;
  }
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
    @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;
